export default __webpack_public_path__ + "static/dateEnded-b05f402f49687e8d615b2bacaf7f343c.svg";